import { Container, Group } from '@mantine/core'
import { SectionTitle } from './SectionTitle'

const PageShell = ({
  children,
  title,
  fullWidth = false,
  action,
}: {
  children: React.ReactNode
  title: string | React.ReactNode
  fullWidth?: boolean
  action?: React.ReactNode
}) => {
  const shellTitle =
    typeof title === 'string' ? (
      <SectionTitle order={1} style={{ margin: 0 }}>
        {title}
      </SectionTitle>
    ) : (
      title
    )

  return (
    <Container
      size="xl"
      py="xl"
      px="xl"
      style={{
        maxWidth: fullWidth ? '100%' : 'var(--mantine-breakpoint-xl)',
      }}
    >
      {action ? (
        <Group justify="space-between" align="center" mb="md">
          {shellTitle}
          {action}
        </Group>
      ) : (
        shellTitle
      )}

      {children}
    </Container>
  )
}

export default PageShell
